<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="公司名称">
              <el-input v-model="searchCondition.name" placeholder="输入公司名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input v-model="searchCondition.legal_person" placeholder="输入联系人" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable ref="apeTable" :data="contractList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            slot="second-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <div>
                {{scope.row.name}}
              </div>
            </template>
          </el-table-column>
           <el-table-column
            slot="second-column"
            align="center"
            label="联系人">
            <template slot-scope="scope">
              <div>
                {{scope.row.legal_person}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="联系方式">
            <template slot-scope="scope">
              <div>
                {{scope.row.legal_phone}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="已配置税源地">
            <template slot-scope="scope">
              <div>
                <template v-if="Array.isArray(scope.row.channel_settlements) && scope.row.channel_settlements.length">
                  <el-tag
                    v-for="(item, index) in scope.row.channel_settlements"
                    :key="index"
                    type="info"
                    size="mini"
                    class="tax-tag"
                  >
                    {{ item }}
                  </el-tag>
                </template>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType=='text'"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span>
                <!-- v-if="userPermissions.indexOf('contract_config_edit') != -1" -->
                <el-button size="mini" @click="editButton(scope.row)">编辑</el-button>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="debouncedrawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="contractForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="公司名称" prop="name">
                <el-input disabled v-model="formData.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="选择税源地" prop="channel_settlements">
                <el-select v-model="formData.channel_settlements" multiple filterable placeholder="请选择税源地" style="width: 100%">
                  <el-option
                    v-for="item in taxSourceList"
                    :key="item.channel_name"
                    :label="item.channel_name"
                    :value="item.channel_name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import {debounce} from '../../utils/utils.js'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
  },
  data() {
    return {
      contractId: '',
      // 搜索条件
      searchCondition:{},
      loadingStaus: true,
      columns: [],
      // 表格列表数据
      contractList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        name:'',
        channel_settlements:[],
      },
      // 表单验证
      rules: {
        name: [
          {required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        // channel_settlements: [
        //   {required: true, message: '请选择税源地', trigger: 'change' },
        // ]
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        title: '编辑签约配置',
        width_height: '480px',
      },
      // 税源地列表（用于下拉选择）
      taxSourceList: [],
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
  },
  methods: {
    //获取全部税源地
    async getTaxSourceList(company_id) {
      let result = await this.$api.getContractConfigSettlementList({company_id})
      if(result) {
        this.taxSourceList = result
      }
    },
    // 搜索
    searchButton() {
      this.initContractList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initContractList()
    },
    // 响应编辑按钮
    async editButton(row) {
      this.contractId = row.id
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.loading = true
      this.drawerData.title = '编辑签约配置(ID：'+row.id+')'
      this.drawerData.visible = true
      this.formData = {
          name: row.name || '',
          channel_settlements: row.channel_settlements || [],
        }
      await this.getTaxSourceList(row.id)
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.contractId = '';
      this.formData = {
        name:'',
        channel_settlements:[],
      }
      this.$refs['contractForm'].resetFields();
    },
    debouncedrawerConfirm:
      debounce(
        function() {
          this.drawerConfirm()
        },
        2000,
        true
      )
    ,
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['contractForm'].validate((valid) => {
        if (valid) {
          if(this.contractId) {
            this.updateContractConfig(this.formData)
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    //编辑签约配置
    async updateContractConfig(data) {
      let result = await this.$api.updateContractConfig({channel_name:data.channel_settlements, company_id: this.contractId})
      if(result) {
        this.drawerData.visible = false
        this.$refs['contractForm'].resetFields();
        this.initContractList()
      }
    },
    // 初始化签约配置列表
    async initContractList(type) {
      this.loadingStaus = true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.searchCondition
      Object.assign(searchCondition,pagingInfo)
      let { data, pages } = await this.$api.getContractConfigList(searchCondition)
      this.$nextTick(() => {
        this.contractList = data
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus = false
    }
  },
  mounted() {
    this.initContractList()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .table-search
    margin-bottom 12px
  .drag-handle
    font-size 24px
    cursor pointer
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .el-select > .el-input
    width 300px
  .tax-tag
    margin-right 4px
    margin-bottom 2px
</style>
